import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { selectedDealership } from '../../../../store/selectors/dealershipSelector'
import request from '../../../request'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const useGetAudienceMetricsByAudienceId = (params: any) => {
  const dealership = useDealership()

  return useQuery<any, Error>(
    ['dealership', dealership?.id, 'audiences', 'metrics', params],
    () =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/audiences/${params.audience_id}/metrics`,
        method: 'GET',
        params: params,
      }).then((res: any) => res.data),
    {
      enabled: !!dealership?.id && !!params.audience_id,
      keepPreviousData: true,
    },
  )
}
